import { BASE_API_CONFIG } from "util/Api";
import { NETWORK_METHOD } from "util/ApiHelper";

export const MY_EXIM_API = {
  getLogin: (params) => ({
    method: NETWORK_METHOD.POST,
    url: `${BASE_API_CONFIG.baseURL}/auth/login`,
    data: { username: params.email, password: params.password },
    config: {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    },
  }),

  verifyWhatsAppOtp: (params) => ({
    method: NETWORK_METHOD.POST,
    url: `${BASE_API_CONFIG.baseURL}/auth/whatsapp/login/verify-otp`,
    data: { mobile: params.mobile, otp: params.otp },
    config: {
      headers: { "Content-Type": "application/json" },
    },
  }),

  verifyEmailOtp: (params) => ({
    method: NETWORK_METHOD.POST,
    url: `${BASE_API_CONFIG.baseURL}/auth/email/login/verify-otp`,
    data: { email: params.email, otp: params.otp },
    config: {
      headers: { "Content-Type": "application/json" },
    },
  }),
  
  checkCurrentPassword: (params) => {
    return {
      method: NETWORK_METHOD.POST,
      url: `${BASE_API_CONFIG.baseURL}/auth/currentpassword/check`,
      data: { id: params.id, password: params.password, isPrimary: params.isPrimary, email: params.email},
      config: {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      },
    };
  },
  createUser: (params) => ({
    method: NETWORK_METHOD.POST,
    url: `${BASE_API_CONFIG.baseURL}/users`,
    data: {
      name: params?.name,
      email: params?.email,
      companyName: params?.company,
      mobile: params?.mobile,
      businessTypeId: params?.businessType,
      country: params?.countryName,
      countryCode: params?.countryCode,
      gstNumber: params?.gstNumber,
      loadingPort:params?.loadingPort,
      portId: params?.portId,
      port: params?.port,
      portPairs: params.portPairs,
      ...(params?.status && {status: params.status,}),
      ...(params?.referrer && { referrer: params.referrer })
    },
    config: {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    },
  }),
  forgotPassword: (params) => ({
    method: NETWORK_METHOD.POST,
    url: `${BASE_API_CONFIG.baseURL}/users/forgotpassword`,
    data: { email: params.emailId },
  }),
  updatedPassword: (params) => ({
    method: NETWORK_METHOD.POST,
    url: `${BASE_API_CONFIG.baseURL}/users/resetpassword`,
    data: { password: params.password, resetpasswordToken: params.token },
  }),
  sendOTP: (params) => ({
    method: NETWORK_METHOD.GET,
    url: `${BASE_API_CONFIG.baseURL}/auth/whatsapp/otp?mobile=${params.mobile}`,
  }),
  verifyOTP: (params) => ({
    method: NETWORK_METHOD.GET,
    url: `${BASE_API_CONFIG.baseURL}/auth/whatsapp/verify?mobile=${params.mobile}&code=${params.code}`,
  }),
  businessType: () => ({
    method: NETWORK_METHOD.GET,
    url: `${BASE_API_CONFIG.baseURL}/businesstypes`,
  }),
};
